module.exports = {
  // 是否开启多语言
  multiLanguage: '多语言',
  // 拒绝访问
  accessDenied: 'access denied',
  // 很抱歉，资源未找到
  notFound: 'Sorry, resource not found',
  // 网络超时
  networkTimeout: 'network timeout',
  // 未授权，请重新登录
  unauthorized: 'Unauthorized, please log in again',
  // 登录已过期
  loginExpired: 'Login expired',
  // 重新登录
  reRegister: 're-register',
  // 登陆已过期，重新登陆
  loginOut: 'Login has expired, please login again',
  // 系统服务错误
  systemServiceError: '系统服务错误',
  // 请求失败
  requestFailed: 'request failed',
  // 系统提示
  systemHint: 'System Hint',
  // 自定义列
  customColumn: 'custom column',
  title: 'Easy Farm Cloud', // 动物管理系统
  company: 'Shanghai Jizhi animal husbandry technology Co., Ltd', // 上海楫智牧业科技有限公司
  help: 'Help', // 帮助
  privacy: 'Privacy', // 隐私
  pleaseSelectTenant: 'Please Select Tenant',
  clause: 'Clause', // 条款
  produce: 'Produce', // 出品
  welcome: 'Welcome', // 欢迎您
  welcomeBack: 'Welcome back', // 欢迎回来
  welcomeToTheSmartFarmSystem: 'Welcome to the Easy Farm Cloud', // 欢迎使用动物管理系统
  currentEnvironmentIs: 'Current environment is:', // 当前环境为：
  currentLoginCompanyIs: 'Current login company is:', // 当前登录公司为：
  searchMenu: 'Search menu', // 搜索菜单
  systemSettings: 'System settings', // 系统设置
  changePassword: 'Change Password', // 密码修改
  switchDepartment: 'Switch Department', // 切换部门
  cleanCache: 'Clean cache',// 清理缓存
  goodMorning: 'Good morning',//上午好
  goodMornings: 'Good morning',//早上好
  goodAfternoon: 'Good afternoon',//中午好
  goodAfternoons: 'Good afternoon',//下午好
  goodEvening: 'good evening',//晚上好
  languageSwitching: 'Language Switching',//语言切换
  mainLanguage: 'Main Language',//主语言
  subLanguage: 'Sub Language',//次语言
  overallStyleSetting: 'Overall Style Setting',//整体风格设置
  darkMenuStyle: 'Dark Menu Style',//暗色菜单风格
  brightMenuStyle: 'Bright Menu Style',//亮色菜单风格
  themeColor: 'Theme Color',//主题色
  navigationMode: 'Navigation Mode',//导航模式
  sidebarNavigation: 'Sidebar Navigation',//侧边栏导航
  topBarNavigation: 'Top Bar Navigation',//顶部栏导航
  topBarNavigationTip: 'This setting is only valid when [top bar navigation]',//该设定仅 [顶部栏导航] 时有效
  fixed: 'Fixed',//固定
  flowType: 'Flow Type',//流式
  contentAreaWidth: 'Content Area Width',//内容区域宽度
  fixedHeader: 'Fixed Header',//固定 Header
  hideHeaderWhenSliding: 'Hide Header When Sliding',//下滑时隐藏 Header
  fixedSideMenu: 'Fixed Side Menu',//固定侧边菜单
  otherSettings: 'Other Settings',//其他设置
  colorWeakMode: 'Color Weak Mode',//色弱模式
  multiTabMode: 'Multi Tab Mode',//多页签模式
  settingTips: 'The configuration bar is only used for preview in the development environment and will not be displayed in the production environment. Please modify the configuration file manually',//配置栏只在开发环境用于预览，生产环境不会展现，请手动修改配置文件
  home: 'Home',//首页
  shuaxin: 'reload tab',//刷新
  guanbizuoce: 'close tabs to left',//关闭左侧
  guanbiyouce: 'close tabs to right',//关闭右侧
  guanbiqita: 'close other tabs'//关闭其他
}